'use strict';

class GroupListCtrl {
  // data will hold the list of groups
  data;
  constructor($stateParams, $location, LoaderSvc, GroupSvc, GrpTypeSvc,
    FileSaveSvc) {
    LoaderSvc.start('Loading Groups...');

    var that = this;
    var groupId = $stateParams.groupId || $stateParams.ctxId;
    that.groupId = groupId;
    var groupTypeId = $stateParams.typeId;
    this.typeId = groupTypeId;

    // default filter
    this.order = 'name';
    this.searchFiled = 'name';
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    GrpTypeSvc.get({groupId, id: groupTypeId}).$promise
      .then(function(gt) {
        that.groupType = gt;
        if(gt.parentType) {
          that.parentLabel = gt.parentType.name;
        }
      }).then(function() {
        return GroupSvc.query({groupId, groupTypeId}).$promise;
      })
      .then(function(data) {
        that.data = data;
        LoaderSvc.stop();
      })
      .catch(function() { LoaderSvc.stopError('Error loading groups'); });

    this.download = function() {
      var fields = [{label: 'Group', value: 'name'},
        {label: 'Members', value: 'memberCount'},
        {label: 'Active', value: 'active'}];
      if(that.parentLabel) {
        fields.push({label: that.parentLabel, value: 'parentGroup.name'});
      }

      var fileName = that.groupType.plural || that.groupType.name + 's';
      FileSaveSvc.saveAsCsv({ data: this.data, fields}, fileName, true);
    };
  }
}

GroupListCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'GroupSvc',
  'GrpTypeSvc',
  'FileSaveSvc'
];

export default GroupListCtrl;
